module.exports = __webpack_public_path__ + "img/R-8888.0a82035d.png";